import { synUtil } from "../../../../javascript/Utilities";
import { AjaxSolr } from "../../core/Core.js";

(function ($) {

    AjaxSolr.ResultWidget = AjaxSolr.AbstractWidget.extend({
        start: 0,

        beforeRequest: function () {
            let $target = $(this.target);

            this.clearUI();
            // Show AJAX animation in result list
            let top = "-" + ($target.outerHeight() - 80).toString() + "px";
            let left = (($target.outerWidth() / 2) - 24).toString() + "px";
            $("<img style='position:relative;top:" + top + ";left:" + left + "' src='assets/images/loading_image.gif' class='synAjaxLoad_animation' />").insertAfter($target);
        },
        clearUI: function () {
            let $target = $(this.target);
            $target.addClass("baseWidget");
            $target.addClass("resultWidget");
            if ($target.synList("isInitialized")) {
                $target.synList("clear");
            }
        },

        facetLinks: function (facet_field, facet_values) {
            let links = [];
            if (facet_values) {
                for (let i = 0, l = facet_values.length; i < l; i++) {
                    if (facet_values[i] != undefined) {
                        links.push(
                            $('<a href="#"></a>')
                                .text(kendo.htmlEncode(facet_values[i]))
                                .click(this.facetHandler(facet_field, facet_values[i]))
                        );
                    }
                    else {
                        links.push('no items found in current selection');
                    }
                }
            }
            return links;
        },

        facetHandler: function (facet_field, facet_value) {
            let self = this;
            return function () {
                self.manager.store.remove('fq');
                self.manager.store.addByValue('fq', facet_field + ':' + AjaxSolr.Parameter.escapeValue(facet_value));
                self.doRequest();
                return false;
            };
        },

        afterRequest: function () {
            $(this.target).synList("refresh");
        },
        cleanUp: function () {
            let $target = $(this.target);
            // Remove AJAX animation in result list
            $target.next(".synAjaxLoad_animation").remove();
            //$target.synList("resize");
        },
        template: function (doc) {
            let snippet = '';
            if (doc.contentfulltext_unstemmed.length > 300) {
                snippet += doc.dateline + ' ' + kendo.htmlEncode(doc.contentfulltext_unstemmed.substring(0, 300));
                snippet += '<span style="display:none;">' + kendo.htmlEncode(doc.contentfulltext_unstemmed.substring(300));
                snippet += '</span> <a href="#" class="more">more</a>';
            }
            else {
                snippet += kendo.htmlEncode(doc.contentfulltext_unstemmed);
            }

            let output = '<div class="doc"><h2>' + doc.name + '</h2>';
            output += '<p id="links_' + doc["cgdocument.docid_i"] + '" class="links"></p>';
            output += '<p>' + snippet + '</p></div>';
            return output;
        },
        init: function () {
            $(document).on('click', 'a.more', function () {
                let $this = $(this),
                    span = $this.parent().find('span');

                if (span.is(':visible')) {
                    span.hide();
                    $this.text('more');
                }
                else {
                    span.show();
                    $this.text('less');
                }

                return false;
            });
        }
    });

})(jQuery);